export default __webpack_public_path__ + "8c8a4ae401ff9b95513b7e6561596d07.svg";